var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 516,
    viewBox: "0 0 504 516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_915_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5 358C49.5 344.193 38.307 333 24.5 333C10.693 333 -0.5 344.193 -0.5 358H49.5ZM504.5 358C504.5 344.193 493.307 333 479.5 333C465.693 333 454.5 344.193 454.5 358H504.5ZM232.287 375.957C223.797 386.843 225.737 402.553 236.623 411.047C247.51 419.537 263.22 417.597 271.713 406.71L232.287 375.957ZM401.713 240.043C410.203 229.157 408.263 213.447 397.377 204.953C386.49 196.463 370.78 198.403 362.287 209.29L401.713 240.043ZM232.287 406.71C240.78 417.597 256.49 419.537 267.377 411.047C278.263 402.553 280.203 386.843 271.713 375.957L232.287 406.71ZM141.713 209.29C133.221 198.403 117.511 196.463 106.624 204.953C95.7373 213.447 93.7957 229.157 102.287 240.043L141.713 209.29ZM227 391.333C227 405.14 238.193 416.333 252 416.333C265.807 416.333 277 405.14 277 391.333H227ZM277 24.6667C277 10.8597 265.807 -0.333313 252 -0.333313C238.193 -0.333313 227 10.8597 227 24.6667H277ZM-0.5 358V391.333H49.5V358H-0.5ZM-0.5 391.333C-0.5 459.77 53.7523 516.333 122 516.333V466.333C82.5523 466.333 49.5 433.357 49.5 391.333H-0.5ZM122 516.333H382V466.333H122V516.333ZM382 516.333C450.247 516.333 504.5 459.77 504.5 391.333H454.5C454.5 433.357 421.447 466.333 382 466.333V516.333ZM504.5 391.333V358H454.5V391.333H504.5ZM271.713 406.71L401.713 240.043L362.287 209.29L232.287 375.957L271.713 406.71ZM271.713 375.957L141.713 209.29L102.287 240.043L232.287 406.71L271.713 375.957ZM277 391.333V24.6667H227V391.333H277Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_915_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 504,
    height: 516,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.0f280cda745ddb8b38b026e4302c3f24.svg";
export { ForwardRef as ReactComponent };